import { MatterStatus, urlParamToMatterStatus } from "@design-system";
import { Tabs } from "antd";
import React, { useEffect, VFC } from "react";
import { useSearchParams } from "react-router-dom";
import { MatterTableContainer } from "./matter-table-container";
import stylesRaw from "./matter-table-wrapper.css";
const { TabPane } = Tabs;
import { useLocalStorage } from "usehooks-ts";

const styles = stylesRaw as any;

const TabKeys = new Map<MatterStatus, string>([
  [MatterStatus.ClientReview, "1"],
  [MatterStatus.Closed, "2"],
  [MatterStatus.Draft, "3"],
  [MatterStatus.Live, "4"],
  [MatterStatus.Lost, "5"],
]);

export const MatterTableWrapper: VFC = () => {
  const [searchParams] = useSearchParams();
  const matterStatus = searchParams.get("status");

  const [lastUsedTab, setLastUsedTab] = useLocalStorage(
    "last-used-tab",
    TabKeys.get(MatterStatus.Live)
  );

  const stringToEnum = urlParamToMatterStatus(matterStatus);

  const defaultActiveKey = matterStatus ? TabKeys.get(stringToEnum) : lastUsedTab;

  useEffect(() => {
    if (matterStatus) {
      const stringToEnum = urlParamToMatterStatus(matterStatus);
      setLastUsedTab(TabKeys.get(stringToEnum));
    }
  }, [matterStatus]);

  return (
    <Tabs
      onTabClick={(tabKey) => setLastUsedTab(tabKey)}
      defaultActiveKey={defaultActiveKey}
      type="card"
      size="small"
      className={styles.tabs}
    >
      <TabPane tab="Client Review" key={TabKeys.get(MatterStatus.ClientReview)}>
        <MatterTableContainer status={MatterStatus.ClientReview} />
      </TabPane>
      <TabPane tab="Closed" key={TabKeys.get(MatterStatus.Closed)}>
        <MatterTableContainer status={MatterStatus.Closed} />
      </TabPane>
      <TabPane tab="Draft" key={TabKeys.get(MatterStatus.Draft)}>
        <MatterTableContainer status={MatterStatus.Draft} />
      </TabPane>
      <TabPane tab="Live" key={TabKeys.get(MatterStatus.Live)}>
        <MatterTableContainer status={MatterStatus.Live} />
      </TabPane>
      <TabPane tab="Lost" key={TabKeys.get(MatterStatus.Lost)}>
        <MatterTableContainer status={MatterStatus.Lost} />
      </TabPane>
    </Tabs>
  );
};
